import React, { useEffect } from 'react';
import { useApp } from '../data/ColisContext';

const COLORS = {
  success: '#10B981',
  error:   '#EF4444',
  info:    '#4F46E5',
};

const BG = {
  success: '#ECFDF5',
  error:   '#FEF2F2',
  info:    '#EEF2FF',
};

const ICONS = {
  success: '✅',
  error:   '❌',
  info:    'ℹ️',
};

export default function Toast() {
  const { toast, dismissToast } = useApp();

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(dismissToast, 3500);
    return () => clearTimeout(t);
  }, [toast, dismissToast]);

  if (!toast) return null;

  return (
    <div style={{
      position:    'fixed',
      top:         24,
      right:       24,
      zIndex:      9999,
      background:  BG[toast.type] || 'white',
      borderRadius: 14,
      padding:     '14px 16px',
      boxShadow:   '0 14px 50px rgba(2,6,23,0.18)',
      border:      `1px solid rgba(2,6,23,0.08)`,
      borderLeft:  `5px solid ${COLORS[toast.type] || COLORS.info}`,
      display:     'flex',
      alignItems:  'center',
      gap:         10,
      maxWidth:    340,
      animation:   'slideIn 0.3s ease-out',
    }}>
      <span style={{ fontSize: 18 }}>{ICONS[toast.type] || ICONS.info}</span>
      <span style={{ color: '#0f172a', fontWeight: 800, fontSize: 14, flex: 1, lineHeight: 1.25 }}>
        {toast.message}
      </span>
      <button
        onClick={dismissToast}
        style={{
          background: 'rgba(255,255,255,0.65)',
          border: '1px solid rgba(2,6,23,0.08)',
          cursor: 'pointer',
          color: '#475569',
          fontSize: 18,
          lineHeight: 1,
          width: 28,
          height: 28,
          borderRadius: 10,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
